import { jsx as _jsx } from "react/jsx-runtime";
import { useColorScheme } from '@mui/material/styles';
import { useEffect } from 'react';
export const THEME_MODE_STORAGE_KEY = 'themeMode';
/**
 * Used by WDSThemeProvider, this simply applies the given theme using the MUI hook.
 *
 * It is a faux component and does not render anything. It needs to be this way as it has to exist inside the WDSThemeProvider
 * @param param0
 * @returns
 */
export function ThemeSetter({ mode }) {
    const { setMode } = useColorScheme();
    // Only react to the mode *prop* changing — not to MUI's internal mode.
    // MUI has its own cross-tab sync via the 'mui-mode' storage key.
    // If we also depended on MUI's currentMode here, a cross-tab storage
    // event would temporarily make currentMode !== mode (before WDS state
    // updates), causing ThemeSetter to call setMode() with the old value
    // and producing a visible flicker.
    useEffect(() => {
        setMode(mode);
    }, [mode, setMode]);
    return _jsx("span", {});
}
export function getThemeStyleLocalStorage() {
    const val = localStorage.getItem(THEME_MODE_STORAGE_KEY);
    if (val === 'light' || val === 'dark') {
        return val;
    }
    return undefined;
}
export function setThemeStyleLocalStorage(mode) {
    return localStorage.setItem(THEME_MODE_STORAGE_KEY, mode);
}
export function getSystemThemeMode() {
    if (typeof window === 'undefined') {
        // If there is no window, we must be Server-side rendering, so we default to light
        return 'light';
    }
    const darkThemeSystem = window.matchMedia('(prefers-color-scheme: dark)');
    if (darkThemeSystem.matches) {
        return 'dark';
    }
    return 'light';
}
//# sourceMappingURL=themeUtils.js.map